/* eslint-disable global-require */

export default [
  {
    path: '/patients-ui/ping',
    getComponent(nextState, callback) {
      require.ensure([], () => callback(null, require('./pages/PingPage').default), 'health');
    },
  },
];



// WEBPACK FOOTER //
// ./src/health/routes.js